import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { registerUser } from '../../actions/LoginActions'
import CountryCodes from '../../constants/CountryCodes'
import ReCAPTCHA from 'react-google-recaptcha';
import { isLocalhost, RE_CAPTCHA_KEY } from '../../constants/Configs';
import { Form, Input, Select, Button, notification } from 'antd';
import RegularExpression from '../../constants/RegularExpression';
import { RoutePath } from '../../constants/SitePaths';

//Translations
import { injectIntl, FormattedMessage } from 'react-intl'

const FormItem = Form.Item;
const Option = Select.Option;

/**Registration Form Component*/

class RegistrationForm extends React.Component {
  state = {
    confirmDirty: false,
    captchaCode: "",
    showCaptcha: true
  };

  /** Compare to first password
   * @function
   * @memberOf RegistrationForm
   * @param {Object} rule
   * @param {Object} value
   * @param {callback} callback function
   */
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback(this.props.intl.messages.inconsistent_passwords);
    } else {
      callback();
    }
  }

  /**
   * Handles Google reCaptcha's callback
   * @function
   * @memberOf RegistrationForm
   * @param {Object} response
   * @public
   */

  reCaptchaCallback = (response) => {
    this.setState({ captchaCode: response });
  }

  /**
   * Fires when Google reCaptcha expires
   * @function
   * @memberOf RegistrationForm
   * @param {Object} response
   * @public
   */
  onCaptchaExpired = () => {
    this.setState({ captchaCode: "" })
  }

  componentDidMount() {
      const showCaptcha = !isLocalhost && !window.location.hostname.includes('tst.webaffiliates.net');

      this.setState({showCaptcha});
      if (this.state.showCaptcha) {
          window.recaptchaOptions = {
              lang: this.props.locale
          }
      }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const countryCodes = CountryCodes.map((country, index) => <Option key={country.dial_code + index} value={country.dial_code}>{` (${country.dial_code}) ${country.name}`}</Option>)

    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '+44'
    })(
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        style={{ width: 160 }}>
        {countryCodes}
      </Select>
    );

    const captchaTemplate = this.state.showCaptcha ?
       <FormItem
            extra={!this.state.captchaCode ? this.props.intl.messages.human : ''}
            validateStatus={!this.state.captchaCode ? 'error' : 'success'}
            className='ta--f-12'
          >
            <ReCAPTCHA
              ref="recaptcha"
              sitekey={RE_CAPTCHA_KEY}
              onChange={this.reCaptchaCallback}
              onExpired={this.onCaptchaExpired}
            />
         </FormItem> : '';

    return (
      <Form onSubmit={this.handleSubmit} className="ta--registration-form" >
        <div className="ta--form-title ta--ph-16 ta--pv-16 rtl--text-right"><FormattedMessage id="sign_up" /></div>
        <div className='ta--flex'>
          <div className='ta--mh-16 ta--col-6'>
            <FormItem
              label={this.props.intl.messages.name}
            >
              {getFieldDecorator('name', {
                rules: [
                  { required: true, message: this.props.intl.messages.required_field },
                  { pattern: RegularExpression.ONLY_LETTERS, message: this.props.intl.messages.name_validation_message }
                ],
              })(
                <Input type="text" placeholder={this.props.intl.messages.type_your_name} />
              )}
            </FormItem>

            <FormItem
              label={this.props.intl.messages.surname}
            >
              {getFieldDecorator('surname', {
                rules: [
                  { required: true, message: this.props.intl.messages.required_field },
                  { pattern: RegularExpression.ONLY_LETTERS, message: this.props.intl.messages.name_validation_message }
                ],
              })(
                <Input type="text" placeholder={this.props.intl.messages.type_your_surname} />
              )}
            </FormItem>

            <FormItem
              label={this.props.intl.messages.referral_id}
            >
              {getFieldDecorator('referral_id', {
                rules: [{
                  required: true, message: this.props.intl.messages.input_referral_id,
                },
                { pattern: RegularExpression.ONLY_NUMBERS, message: this.props.intl.messages.required_field }]
              })(
                <Input type="text" placeholder={this.props.intl.messages.type_your_referral_id} />
              )}
            </FormItem>

            <FormItem
              label={this.props.intl.messages.company_name}
            >
              {getFieldDecorator('companyName', {
                rules: [{
                  required: true, message: this.props.intl.messages.input_company_name,
                },
                { pattern: RegularExpression.COMPANY_NAME, message: this.props.intl.messages.invalid_company_name },
                ],
              })(
                <Input type="text" placeholder={this.props.intl.messages.type_your_company_name} />
              )}
            </FormItem>
          </div>

          <div className='ta--mh-16 ta--col-6'>
            <FormItem
              label={this.props.intl.messages.email}
            >
              {getFieldDecorator('email', {
                rules: [{
                  type: 'email', message: this.props.intl.messages.invalid_mail,
                }, {
                  required: true, message: this.props.intl.messages.email_required,
                }],
              })(
                <Input placeholder={this.props.intl.messages.type_your_email} />
              )}
            </FormItem>

            <FormItem
              className="mob-number"
              label={this.props.intl.messages.phone_number}
            >
              {getFieldDecorator('phone', {
                rules: [
                  { required: true, message: this.props.intl.messages.input_phone_number },
                  { pattern: RegularExpression.PHONE_VALIDATION, message: this.props.intl.messages.invalid_phone_number }
                ],
              })(
                <Input className='ta--w100' addonBefore={prefixSelector} type="number" />
              )}
            </FormItem>

           { captchaTemplate }

            <FormItem className="align-center padding-top-two">
              <Button className='ta-w100' loading={this.props.user.isLoading} type="primary" htmlType="submit"
                onClick={this.props.handleSubmit.bind(this, this.props.form, this.props, this.state)}>
                <FormattedMessage id="sign_up" />
              </Button>
            </FormItem>

            <div className='ta--mb-24 ta--text-center'>
              <Link to={RoutePath.LOGIN}>
                <span className='ta--txt-mid-dark'>{this.props.intl.messages.account_question}</span> <span className='ta--txt-mid-dark'>{this.props.intl.messages.go_to}</span> <span>{this.props.intl.messages.sign_in}</span>
              </Link>
            </div>

          </div>
        </div>
      </Form>
    );
  }
}

const Registration = Form.create()(RegistrationForm);

function mapDispatchToProps(dispatch, props) {
  return ({
    handleSubmit: (form, props, state) => {

      if (state.showCaptcha && !state.captchaCode) {
        notification.error({
          key: 'registrationError',
          placement: 'bottomRight',
          duration: 5,
          message: props.intl.messages.human
        });

        return;
      }
      //Validate completed data
      form.validateFields((err, values) => {
        if (!err) {
          values.captchaCode = state.captchaCode;
          dispatch(registerUser(values, props.history));
        }
      });
    }
  })
}

const mapStateToProps = state => {
  return state;
}

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Registration));


// WEBPACK FOOTER //
// ./src/routes/account/Registration.js